<template>
  <div class="dataCenter">
    <div class="fansData">
      <div class="title">粉丝数据</div>
      <div class="data_box">
        <div class="number_box">
          <div class="number">7084</div>
          <div class="fans">总粉丝量</div>
        </div>
        <div class="line"></div>
        <div class="number_box">
          <div class="number">1125</div>
          <div class="fans">近30天粉丝净增</div>
        </div>
      </div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">基础数据</div>
        <div class="left">
          <div class="background">
            <span :class="[{'item':isLive==1}]" @click="changeLive(1)">昨日</span>
            <span :class="[{'item':isLive==2}]" @click="changeLive(2)">近7日</span>
          </div>
        </div>
      </div>
      <div class="tip">每天17-19点更新</div>
      <div class="works">
        <div :class="['show_item',{'active_show_item':activeWorkIndex==item.id}]" v-for="item in showWorkData" :key="item.id" @click="activeWorkItem(item)">
          <div class="value">{{ item.value }}</div>
          <div class="name">{{ item.name }}</div>

        </div>
      </div>
      <div class="worksEcharts" style="display: flex;align-items: center;justify-content: center;color: #999;" v-if="activeWorkIndex==5 && isLive==2">暂无数据</div>
      <div class="worksEcharts" v-else ref="worksEchartsRef"></div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">关注来源</div>
      </div>
      <div class="tip">近7日</div>
      <div class="tip_box">你的粉丝关注来源通过我的主页的方式下降明显</div>
      <div class="table_header" style="color: #999;">
        <div class="name">渠道来源</div>
        <div class="proportion">来源占比</div>
        <div class="compare">对比7日</div>
      </div>
      <div class="table_header" v-for="item in flowFromData" :key="item.name">
        <div class="name">{{ item.name }}</div>
        <div class="proportion"><el-progress :percentage="item.proportion1" color="#6a75f6"></el-progress>
        </div>
        <div class="compare" :style="{color:item.Compare1<0?'#73c97f':'#ea4b35'}">{{ item.Compare1 }}%</div>
      </div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">近7日高互动粉丝排名</div>
      </div>
      <div class="list_item" v-for="(item,index) in InteractiveFansData" :key="item.name">
        <div class="fans_info">
          <span class="number">
            <img v-if="index==0" style="width: 16px;" src="../../assets/img/incomeData/num1.png" alt="">
            <img v-else-if="index==1" style="width: 18px;" src="../../assets/img/incomeData/num2.png" alt="">
            <img v-else-if="index==2" style="width: 18px;" src="../../assets/img/incomeData/num3.png" alt="">
            <span v-else>{{ index+1 }}</span>
          </span>
          <img class="avator" :src="item.url" alt="">
          <span class="name">{{ item.name }}</span>
        </div>
        <div class="value">
          互动指数:{{ item.value }}
        </div>

      </div>
      <div class="tip_box" style="color: #161722;display: flex;justify-content:center; align-items: center;">涨粉灵感 <i class="el-icon-arrow-right" style="margin-left: 5px;margin-top: 2px;"></i></div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">热门在线时段</div>
      </div>
      <div class="tip">每天17-19点更新</div>
      <div class="OnlineSession">
        <div class="session_box">
          <div class="value">22-23</div>
          <div class="sort">排名第一</div>
        </div>
        <div class="session_box">
          <div class="value">20-21</div>
          <div class="sort">排名第二</div>
        </div>
        <div class="session_box">
          <div class="value">21-22</div>
          <div class="sort">排名第三</div>
        </div>
      </div>
    </div>
    <div class="operatingData">
      <div class="header">
        <div class="title">互动贡献</div>
      </div>
      <div class="tip">近7日增量变化</div>
      <div class="table_header" style="color: #999;">
        <div class="name">互动渠道</div>
        <div class="proportion">增量数字(条)</div>
        <div class="compare">对比7日</div>
      </div>
      <div class="table_header" v-for="item in InteractiveContribution" :key="item.name">
        <div class="name">{{ item.name }}</div>
        <div class="proportion"><el-progress :percentage="calculatePercentage(item.proportion1)" color="#6a75f6" :format="formatProgress"></el-progress>
        </div>
        <div class="compare" :style="{color:item.Compare1<0?'#73c97f':'#ea4b35'}">{{ item.Compare1 }}%</div>
      </div>
    </div>

  </div>
</template>
      
<script>
import { fansBasicsData } from "./js/Operatingdata";
export default {
  data() {
    return {
      isLive: 2,
      showWorkData: [
        {
          name: "粉丝净增",
          value: "65",
          id: 1,
          unit: "",
        },
        {
          name: "脱粉量",
          value: "106",
          id: 2,
          unit: "",
        },
        {
          name: "回访粉丝量",
          value: "171",
          id: 3,
          unit: "",
        },
      ],
      activeWorkIndex: 1,
      fansBasicsDataValue: [],
      flowFromData: [
        {
          name: "视频推荐",
          proportion1: 58.1,
          Compare1: -75.6,
        },
        {
          name: "我的主页",
          proportion1: 28.1,
          Compare1: -76.4,
        },
        {
          name: "视频详情页",
          proportion1: 13.8,
          Compare1: -69.4,
        },
      ],
      InteractiveFansData: [
        {
          url: require("../../assets/img/fansData/av1.png"),
          name: "靓66",
          value: "11",
        },
        {
          url: require("../../assets/img/fansData/av2.png"),
          name: "帅气鲨鱼",
          value: "10",
        },
        {
          url: require("../../assets/img/fansData/av3.png"),
          name: "客家老徐",
          value: "10",
        },
        {
          url: require("../../assets/img/fansData/av4.png"),
          name: "flag-减肥减到85....",
          value: "9",
        },
        {
          url: require("../../assets/img/fansData/av5.png"),
          name: "用户ldi",
          value: "9",
        },
      ],
      InteractiveContribution: [
        {
          name: "播放",
          proportion1: 8414,
          Compare1: -12.5,
        },
        {
          name: "点赞",
          proportion1: 224,
          Compare1: -28,
        },
        {
          name: "评论",
          proportion1: 11,
          Compare1: 83.3,
        },
        {
          name: "分享",
          proportion1: 0,
          Compare1: -100,
        },
      ],
    };
  },
  components: {},
  mounted() {
    let obj = fansBasicsData.find((item) => item.id == this.activeWorkIndex);
    this.fansBasicsDataValue = obj.data;
    this.getWorkEcharts(this.fansBasicsDataValue, 1);
  },

  methods: {
    changeLive(id) {
      // this.isLive = id;
    },
    activeWorkItem(item) {
      this.activeWorkIndex = item.id;
      let obj = fansBasicsData.find((item) => item.id == this.activeWorkIndex);
      this.fansBasicsDataValue = obj.data;
      this.getWorkEcharts(this.fansBasicsDataValue, 1);
    },
    getWorkEcharts(y, type) {
      const today = new Date();
      // 生成近七日的日期数组，按从小到大排列
      const dates = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        dates.push(`${month}-${day}`);
      }
      var chart = null;
      let index = 1;
      let arrData = [];
      if (type == 1) {
        chart = this.$echarts.init(this.$refs.worksEchartsRef);
        index = this.activeWorkIndex;
        arrData = this.showWorkData;
      }
      let option = {
        grid: {
          left: 42,
        },
        xAxis: {
          type: "category",
          data: dates,
          boundaryGap: false,
          splitLine: {
            show: false, // 隐藏 x 轴的分隔线
          },
          axisTick: {
            show: false, // 隐藏 x 轴的刻度线（即坐标文字旁的小竖线）
          },
          axisLabel: {
            show: true, // 保留 x 轴的标签,
            color: "#999999",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          formatter: (params) => {
            console.log(params);
            let res = `<div style="color:#666;box-shadow: 0 5px 10px 1px rgba(32, 32, 32, 0.05);padding:10px;border-radius:4px">
              <div >${params[0].axisValueLabel}<div>
                <div style="display: flex;align-items: center;margin-top: 6px;font-size:14px;"><span style="width: 10px;height: 10px;border-radius: 10px;background: #93ade6;margin-right: 5px;"></span><span style="margin-right: 10px;">${
                  arrData[index - 1].name
                }</span><span>${params[0].value}${
              arrData[index - 1].unit
            }</span><div>
              <div>`;
            return res;
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true, // 隐藏 y 轴的分隔线
            lineStyle: {
              color: "#F2F2F4", // 设置轴线颜色为红色
              type: "dashed", // 设置轴线为虚线
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter: function (value) {
              return value + arrData[index - 1].unit; // 给标签数字加上单位
            },
          },
          min: 0,
        },
        series: [
          {
            data: y,
            type: "line",
            smooth: true,
            color: "#93ade6",
          },
        ],
      };
      chart.setOption(option);
      window.onresize = () => {
        // 基础数据
        chart.resize();
      };
    },
    calculatePercentage(value) {
      const maxValue = Math.max(
        ...this.InteractiveContribution.map((item) => item.proportion1)
      );
      return (value / maxValue) * 100;
    },
    // 自定义进度条显示格式，显示具体数值
    formatProgress(percentage, rawValue) {
      const index = this.InteractiveContribution.findIndex(
        (item) => this.calculatePercentage(item.proportion1) === percentage
      );
      return this.InteractiveContribution[index].proportion1;
    },
  },
};
</script>
      
<style scoped lang="scss">
.dataCenter {
  padding: 10px;
  box-sizing: border-box;
  .fansData {
    width: 100%;
    height: 150px;
    background: skyblue;
    border-radius: 4px;
    background: url("../../assets/img/fansData/fansDataBac.png") no-repeat;
    background-size: 100% 100%;
    padding: 20px;
    box-sizing: border-box;
    color: #fff;
    .title {
      font-size: 17px;
    }
    .data_box {
      display: flex;
      align-items: center;
      margin-top: 36px;
      font-size: 16px;
      .line {
        width: 2px;
        height: 30px;
        background: #85b4f4;
        margin-right: 30px;
      }
      .number_box {
        margin-right: 30px;
        .number {
          font-size: 26px;
          font-weight: 600;
        }
        .fans {
          color: #9bc6f7;
          font-size: 14px;
        }
      }
    }
  }
  .operatingData {
    margin-top: 20px;
    width: 100%;
    padding: 20px 10px;
    background: #fff;
    box-sizing: border-box;
    .header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .title {
        font-weight: 700;
        font-size: 16px;
      }
      .left {
        .background {
          background: #f2f2f2;
          padding: 4px 6px;
          border-radius: 2px;
          font-size: 12px;
          .item {
            background: #fff;
            padding: 2px 3px;
          }
          span {
            margin-right: 5px;
            border-radius: 2px;
            padding: 2px 3px;
          }
        }
      }
    }
    .tip {
      color: #999;
      font-size: 12px;
      margin-top: 5px;
    }
    .tip_box {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border-radius: 4px;
      background: #f7f7f8;
      color: #b9babc;
      font-size: 13px;
      padding: 0 10px;
      box-sizing: border-box;
      margin-top: 10px;
    }
    .show_data {
      display: flex;
      justify-content: space-between;
      height: 30px;
      align-items: center;
      .right {
        display: flex;
        align-items: center;
        .el-icon-arrow-right {
          margin-left: 5px;
          font-size: 16px;
          font-weight: 600;
        }
      }
      .left {
        font-weight: 600;
      }
    }
    .works {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding-top: 10px;
      .show_item {
        width: 33.33%;
        // height: 56px;
        padding: 6px;
        padding-bottom: 10px;
        padding-right: 5px;
        box-sizing: border-box;
        border-radius: 4px;
        cursor: pointer;
        .name {
          font-size: 12px;
          color: #999;
        }
        .value {
          margin-top: 5px;
          font-weight: 600;
        }
      }
      .active_show_item {
        background: #fafafa;
      }
    }
    .showPromotiondata {
      display: flex;

      .data {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 5px;
        box-sizing: border-box;
        color: #999;
        &:nth-of-type(2) {
          margin-left: 5px;
        }
      }
    }
    .worksEcharts {
      width: 100%;
      height: 250px;
    }
    .table_header {
      display: flex;
      margin-top: 10px;

      .name {
        width: 25%;
      }
      .proportion {
        width: 55%;
      }
      .compare {
        width: 20%;
        text-align: right;
        padding-right: 4px;
        box-sizing: border-box;
      }
    }
    .list_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0;
      .fans_info {
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        .number {
          color: #d7d7e2;
          font-size: 16px;
          font-weight: 600;
          display: inline-block;
          width: 16px;
          text-align: center;
        }
        .avator {
          width: 40px;
          height: 40px;
          margin: 0 10px;
        }
        .name {
          color: #2d2f38;
        }
      }
      .value {
        width: 70px;
        color: #97989c;
        font-size: 12px;
        text-align: left;
      }
    }
    .OnlineSession {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      margin-top: 20px;
      .session_box {
        font-size: 15px;
        .value {
          font-size: 19px;
          font-weight: 600;
          text-align: center;
        }
        .sort {
          text-align: center;
          color: #999;
        }
      }
    }
  }
}
::v-deep .el-progress-bar__outer {
  height: 12px !important;
  border-radius: 0px !important;
}
::v-deep .el-progress-bar__inner {
  border-radius: 0px !important;
}
</style>
      